export default __webpack_public_path__ + "static/media/adddocIcon.d33e5a88.svg";